import axios from "axios";

const BASEURL = process.env.REACT_APP_API_URL || 'https://api.caleffiweb.it/api/v1/';

const customAxios = (contentType, dispatch) => {
  const axiosInstance = axios.create({
    baseURL: BASEURL,
    headers: { "Content-Type": contentType },
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `${token}`;
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const { response: { status } } = error;
      if (status === 401 || status === 403) {

        localStorage.removeItem('token');  
        window.location.href = "/auth";      }
      
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};

export { customAxios };
